import { Box, Stack, SxProps, Theme, useTheme } from '@mui/material';
import { useCallback } from 'react';
import { IconButton, Paper, SizingMultiplier, Typography } from '@ocx/ui';
import { LocationArrow2Icon } from '@ocx/ui-icons';
import { Coordinates } from '../../modules/stores/types';
import { OfferLocationsCarouselItemOnClickParams } from './types';

const TEXT_OVERFLOW_ELLIPSIS_SX: SxProps = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const iconSx: SxProps<Theme> = (theme: Theme) => ({
  ml: SizingMultiplier.md,
  color: theme.palette.Receipts.offerLinkColor,
  backgroundColor: theme.palette.Receipts.iconBackground,
  borderRadius: theme.shape.borderRadius / 2,
});

type OfferLocationsCarouselItemProps = {
  uuid: string;
  name: string;
  address: string;
  coordinates: Coordinates;
  onClick?: (params: OfferLocationsCarouselItemOnClickParams) => void;
};

export const OfferLocationsCarouselItem = ({
  uuid,
  name,
  address,
  coordinates,
  onClick,
}: OfferLocationsCarouselItemProps) => {
  const theme = useTheme();

  const handleOnClick = useCallback(() => {
    onClick?.({ uuid, coordinates });
  }, [coordinates, onClick, uuid]);

  return (
    <Paper sx={{ border: `1px solid ${theme.palette.background.box}`, borderRadius: SizingMultiplier.md }}>
      <Stack direction="row" justifyContent="space-between" flexWrap="nowrap">
        <Box sx={TEXT_OVERFLOW_ELLIPSIS_SX}>
          <Typography variant="subtitle1" sx={TEXT_OVERFLOW_ELLIPSIS_SX}>
            {name}
          </Typography>

          <Typography variant="body2" sx={TEXT_OVERFLOW_ELLIPSIS_SX} color="text.secondary">
            {address}
          </Typography>
        </Box>

        <IconButton onClick={handleOnClick} sx={iconSx}>
          <LocationArrow2Icon />
        </IconButton>
      </Stack>
    </Paper>
  );
};
